import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { withStyles } from '@material-ui/core/styles'
import { DialogContent } from '@material-ui/core'

const styles = theme => {}

class FullscreenImage extends Component {

    render(){
        return (
            <DialogContent
                style={{
                    width: 'auto',
                    maxWidth: '90vw',
                    padding: '5px'
                }}
                >
                <img
                    src={this.props.image}
                    alt='erro'
                    style={{
                        display: 'block',
                        height: 'auto',
                        maxHeight: '80vh',
                        width: '100%'
                    }}/>
            </DialogContent>
        )
    }
}

// .image {
//     background-image: url("../images/background.jpg");
//     background-size: cover;
//     background-position: center;
//     width: 100vw;
//     height: 100vh;
//     display: flex;
// }

function mapStateToProps(state) {
    return {
    }
}

function mapDispatchToProps(dispatch) {
    return {

    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(FullscreenImage)));